import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MasterData } from '@card-software/nexus-utilities';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-edit-masterdata-dialog',
  templateUrl: './edit-masterdata-dialog.component.html',
  styleUrl: './edit-masterdata-dialog.component.scss',
})
export class EditMasterdataDialogComponent implements OnInit {
  item: MasterData;
  confirmCallback: (item: MasterData) => void;
  cancelCallback: (item: null) => void;
  canEdit = false;

  itemName = new FormControl('', [Validators.required]);

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {
    this.item = { ...config.data.item };
    this.confirmCallback = config.data.confirmCallback;
    this.cancelCallback = config.data.cancelCallback;
    this.canEdit = config.data.canEdit ?? false;
  }

  ngOnInit(): void {
    this.itemName.setValue(this.item.name);
  }

  onSave() {
    if (this.itemName.valid) {
      const newMasterData = {
        ...this.item,
        name: this.itemName.value!,
      };
      this.confirmCallback?.(newMasterData);
      this.ref.close(newMasterData);
    }
  }

  onCancel() {
    this.cancelCallback?.(null);
    this.ref.close(null);
  }
}
